import Vue from 'vue';
import Router from 'vue-router'; 
import userCenterPage from '@/components/view/userCenterPage.vue';
import HomePage from '@/components/view/HomePage.vue';
import LoginPage from '@/components/view/LoginPage.vue';
import unityEndPage from '@/components/view/unityEndPage.vue';
import ModelDetaiPage from '@/components/view/ModelDetaiPage.vue';

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage
  },
  {
    path: '/userCenter',
    name: 'userCenter',
    component: userCenterPage
  },
  {
    path: '/unityEndPage',
    name: 'unityEndPage',
    component: unityEndPage
  },
  {
    path: '/modelDetail',
    name: 'modelDetail',
    component: ModelDetaiPage
  },
  {
    path: '*',
    redirect: '/'
  }
];

const router = new Router({
  mode: 'hash', // 可以选择使用 'hash' 或 'history'
  routes
});

export default router;
